import type { FormInstance } from 'antd';
import type { StoreApi } from 'zustand';

import { rememberPassword } from '~/services/auth/AuthService';
import type { IRememberPasswordParams } from '~/types/api/Auth';
import type { IAuthStore } from './useAuthStore';

export type IRememberPasswordFormFilter = {
  username: string;
};

export type IRememberPasswordActions = {
  resetStates: () => void;
  setFormFilterInstance: (form: Partial<FormInstance<IRememberPasswordFormFilter>>) => void;
  getParams: () => IRememberPasswordParams;
  handleSubmit: () => Promise<void>;
};

export type IRememberPasswordState = {
  isLoading: boolean;
  formFilterInstance: Partial<FormInstance<IRememberPasswordFormFilter>> | null;
};

export type IRememberPasswordSlice = IRememberPasswordState & IRememberPasswordActions;

const useRememberPasswordSlice = (
  set: StoreApi<IAuthStore>['setState'],
  get: StoreApi<IAuthStore>['getState'],
): IRememberPasswordSlice => ({
  // States
  isLoading: false,
  formFilterInstance: null,

  // Setters
  setFormFilterInstance: form => {
    get().setData(state => {
      state.rememberPasswordSlice.formFilterInstance = form;
    });
  },

  // Actions
  resetStates: () => {
    get().setData(state => {
      state.rememberPasswordSlice.isLoading = false;
      state.rememberPasswordSlice.formFilterInstance = null;
    });
  },
  getParams: () => {
    const { formFilterInstance } = get().rememberPasswordSlice;
    if (!formFilterInstance?.getFieldsValue) {
      throw new Error('Instância do formulário não está definida.');
    }

    const formValues = formFilterInstance.getFieldsValue();

    return {
      username: formValues.username,
    } as IRememberPasswordParams;
  },
  handleSubmit: async () => {
    const { formFilterInstance } = get().rememberPasswordSlice;
    if (!formFilterInstance) return;
    get().setData(state => {
      state.rememberPasswordSlice.isLoading = true;
    });

    try {
      const params = get().rememberPasswordSlice.getParams();
      await rememberPassword(params);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      get().setData(state => {
        state.rememberPasswordSlice.isLoading = false;
      });
    }
  },
});

export default useRememberPasswordSlice;
